import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { AssetFilter } from 'app/models/document';
import { LabelService } from 'app/services/label.service';
import { AssetsSearch, ItemLabel, assetsFilterFields } from '../file-manager.types';
import { Util } from 'app/models/util';
import { FileTypes } from '../../../../../constants'
import { labelColorDefs } from 'app/shared/global-constants';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { UserService } from 'app/services/user.service';
import { Label } from 'app/models/label';
import { Observable, map, startWith } from 'rxjs';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    FormsModule,
    MatTooltipModule,
    NgSelectModule,
    FormsModule,
    MatFormFieldModule,
    FormsModule ,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule
  ],
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
  constructor(
    private labelService: LabelService,
    public util: Util,
    public userService:UserService
    
  ) {

  }
  assestFilter: AssetsSearch = new AssetsSearch()
  @Input() labels: Label[] = []
  fileTypes = FileTypes
  labelColors: any;
  dateRange: string = "any"
  label: string = "any"
  favourite: any = "all"
  @Output() onFilterChanges = new EventEmitter()
  @Input() FilterFields: assetsFilterFields = new assetsFilterFields()

  // users search field
  private searchInterval = null;
  public showSpinner = false;
  public itemsList: any[] = [];
  userInput:any=null

  ngOnInit() {
    this.labelColors = labelColorDefs;
    // this.getLabels();
  }

  getLabels() {
    this.labelService.getLabels().then((res) => {
      this.labels = this.labelService.getData(res);
    }).catch((error) => {
      console.log(error);
    })
  }

  onFilterChange() {

    this.assestFilter.start = this.dateRange == 'any' ? null : this.util.getDateRange(this.dateRange).startDate
    this.assestFilter.end = this.dateRange == 'any' ? null : this.util.getDateRange(this.dateRange).endDate
    this.assestFilter.fileType = this.assestFilter.fileType as any == 'any' ? null : this.assestFilter.fileType
    this.assestFilter.labels = this.label as any == 'any' ? null : [this.label]
    this.assestFilter.favourite  = this.favourite == 'all' ? null : this.favourite
    this.onFilterChanges.emit(this.assestFilter)

  }

  public onValueChanged(event) {
    if(typeof event!='string'){
      this.assestFilter.sharedWithId=event.id
      this.onFilterChanges.emit(this.assestFilter)
      return
    }
    let val = event
  
    clearTimeout(this.searchInterval);
    this.showSpinner = false;
    if (!this.util.isValidated(val.trim()) || val.length < 3) return;
    this.itemsList = [];
    this.searchInterval = setTimeout(() => {
    this.searchUsers(val.trim());
      
    }, 500);
  }

  OnChange(selectedId) {
    this.assestFilter.sharedWithId=selectedId
  }

  private searchUsers(val) {
    this.showSpinner = true;
    this.userService
      .searchUser(val)
      .then((res) => {
        let userList :[] = this.userService.getData(res);
        if(userList.length>0) this.itemsList = userList
        
        this.showSpinner = false;
      })
      .catch((err) => {
        this.showSpinner = false;
        console.log(err);
      });
  }

  displayFn(user){
   return user?.email??user
  }

  clearUserSearch(){
    this.userInput=""
    this.assestFilter.sharedWithId=null
    this.onFilterChanges.emit(this.assestFilter)
  }

  inputFocused: boolean = false;

  onInputFocus(): void {
    this.inputFocused = true;
  }

  onInputBlur(): void {
    this.inputFocused = false;
  }

}
